import './_credit';

/* BOOTSTRAP */
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';
//import * as Popper from '@popperjs/core';

/* FONT AWEWSOME */
import'./font-awesome';

/* PAGE TEMP FONT AWEWSOME */
//import'./font-awesome-temp';

/* WOW */
// import {WOW} from "wowjs";

/* TinySlider */
//import {tns} from 'tiny-slider';

/* Fslightbox */
//import 'fslightbox';

/* Dropdown Menu Hover */
//import './dropdown-menu-hover';

document.addEventListener('DOMContentLoaded', function () {
    /* WOW */
    // let wow = new WOW({
    //     live: false,
    //     animateClass: 'animate__animated'
    // });
    // wow.init();
    /* Fslightbox */
    // refreshFsLightbox();

  //désactiver l'ajoute de la class collapsing a cette collapse bootstrap
  // const collapseElementList = document.querySelectorAll('.collapse')
  // const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl));
  //
  // console.log(collapseList);


});
